<!-- TODO : Error handling needs to be better, and across all the components -->
<!--      : right now if the category throws an error you get a description label -->
@if (teaFlavour || errors.length) {
  @if (errors.length > 0) {
    <div class="m-2">
      <div class="bg-red-500 text-white p-4 rounded">
        <h2 class="text-xl font-bold">Something went wrong:</h2>
        <ul>
          @for (error of errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    </div>
  }
  <div class="m-2">
    <div class="bg-green-900 bg-cover bg-center h-64 flex items-center justify-center rounded dropshadow"
      [ngStyle]="{ 'background-image': 'url(' + headerImageURL + ')' }"
      >
      <h1 class="p-2 text-3xl font-bold text-gray-300 bg-green-900/75 w-full text-center">{{ teaFlavour.name }}</h1>
    </div>
    <tea-shop-fe-truncated-markdown
      class="pt-5 markdown"
      [text]="teaFlavour.description"
      [maxLength]="35"
      [inline]="true"
    ></tea-shop-fe-truncated-markdown>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-5">
      @for (tea of teas; track tea) {
        <tea-shop-fe-tea-item-summary [teaItem]="tea"></tea-shop-fe-tea-item-summary>
      }
    </div>
  </div>
} @else {
  <div class="m-2">
    <div class="animate-pulse">
      <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/6 mb-2"></div>
    </div>
  </div>
}

